import { useCallback, useMemo } from 'react'
import { useHistory } from 'react-router-dom'

import { useObjects } from 'data/hooks/objects'
import { useViews } from 'data/hooks/views'
import { getActionNavigateToTarget } from 'features/actions/utils/getActionNavigateToTarget'

type UseNavigateToActionTargetProps = {
    action?: ActionDto
    record?: RecordDto
}

export function useNavigateToActionTarget({ action, record }: UseNavigateToActionTargetProps) {
    const { data: views = [] } = useViews()
    const { data: objects = [] } = useObjects()

    const { isNavigationTarget, url, shouldHide, target, isUrlRelative, openAs } =
        getActionNavigateToTarget(action, record, views, objects)

    const history = useHistory()
    const navigate = useCallback(() => {
        if (!url) return

        if (openAs === 'new_tab') {
            window.open(url, '_blank')
        } else if (isUrlRelative) {
            setTimeout(() => history.push(url), 50)
        } else {
            window.location.assign(url)
        }
    }, [openAs, url, isUrlRelative, history])

    return useMemo(
        () => ({
            isNavigationTarget,
            url,
            shouldHide,
            target,
            isUrlRelative,
            navigate,
        }),
        [url, shouldHide, target, isUrlRelative, navigate, isNavigationTarget]
    )
}
